import React, { useContext, useState } from 'react';
import { styled } from '@mui/material/styles';
import { 
    Box,
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogActions,
    LinearProgress,
    TextField,
    Typography
} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

import UserContext from '../../../contexts/UserContext';
import ProjectContext from '../../../contexts/ProjectContext';
import {supportTheme} from '../../../theme';

import {
    DialogTextField,
    DialogFooter
} from './SupportDialogStyles';


export default function SupportDialogError(props){
    const { formState, setFormState, handleResubmitReturn, handleClose, errorMessage} = props
    const t = supportTheme
    const { konsolUser } = useContext(UserContext)
    const projectContext = useContext(ProjectContext)



    return (
        <React.Fragment>
            <DialogContent sx={{ 
                color: 'rgb(175, 175, 175)', 
                padding: t.size.panelInset, 
                pt: 10,
                gap: 2, 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center',
                overflow: 'hidden',
            }}>

                <Box
                    sx={{
                        position: "relative",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: '60px',
                        width: '60px',
                        borderRadius: '50%',
                        backgroundColor: t.color.errorMuted,
                        border: `1px solid ${t.color.errorBorder}`,
                    }}
                >

                <ErrorIcon
                    sx={{
                    position: "absolute",
                    fontSize: 40,
                    color: t.color.error,
                    }}
                />
                </Box>

                    <Typography sx={{...t.type.title}}>Error</Typography>
                    <Typography sx={{...t.type.body}}>Something went wrong. Please try submitting again.</Typography>
                    
                    <Box sx={{
                        width: '70%', 
                        maxHeight: '200px',
                        border: `1px solid ${t.color.errorBorder}`, 
                        borderRadius: t.radius.control,
                        p: 1, 
                        mt: 2,
                        overflowY: 'scroll',
                    }}>
                        <Typography variant='overline'>Error info:</Typography>
                        <br></br>
                        <Typography variant='body1' color={t.color.error}>{errorMessage}</Typography>

                    </Box>


            </DialogContent>
            <DialogFooter>
                <DialogActions>
                    <Button 
                        onClick={handleClose} 
                        sx={t.component.secondaryButton}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleResubmitReturn}
                        sx={t.component.primaryButton}
                    >
                        Try again
                    </Button>       
                </DialogActions>
            </DialogFooter>
        </React.Fragment>
    )
}